<template>
    <div @click="$emit('zoomShip', ship.id)" class="border rounded flex p-2 mb-2 hover:bg-gray-100 cursor-pointer">
        <div class="flex-grow">
            <div class="text-xs text-gray-600">Near {{ ship.data.nearCountry }}</div>
            <div class="font-semibold">{{ ship.data.name }}</div>
            <div class="text-sm text-gray-600">
                <span v-if="!ship.data.disembarked">At sea <span v-if="ship.data.daysAtSea"><span>{{ ship.data.daysAtSea || '?' }} days</span></span></span>
                <span v-else>Ship Disembarked</span>
            </div>
        </div>
        <div class="flex items-center my-1">
            <div class="text-center">
                <div class="text-xs leading-loose">{{ ship.data.passengers.onboard ? 'passengers' : 'capacity' }}</div>
                <div>
                    <div class="font-semibold bg-gray-100 w-16 p-1 rounded">{{ (ship.data.passengers.onboard ? ship.data.passengers.onboard : ship.data.passengers.capacity) || '?'}}</div>
                </div>
            </div>
            <div class="text-center ml-6">
                <div class="text-xs leading-loose">cases</div>
                <div>
                    <div class="font-semibold text-white w-12 p-1 rounded" :class="badge(ship.data.casesPositive)">{{ ship.data.casesPositive || '?'}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'SidebarShip',
    props: {
      ship: Object,
    },
    methods: {
      badge(cases) {
        if (cases <= 0) {
          return 'bg-green-500'
        }

        if (cases <= 5) {
          return 'bg-orange-500'
        }

        return 'bg-red-500'
      }
    },
  }
</script>

<style scoped>

</style>
